import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import { show } from "redux-modal";
import { Dispatch } from "redux";
import {
  updateIsMultiSiteRoute,
  selectActiveSite,
} from "../../../redux/modules/_BETA/selections";
import InsightEquips from "./InsightEquips";
import { InsightType } from "../../../utils/routes";
import { setShouldRequestInsights } from "../../../redux/modules/_BETA/requestSchedule";

interface ConnectedProps {
  appSetupComplete: Insite.AppState["appSetup"]["appSetupComplete"];
  userSites: Insite.AppState["userSites"];
  loading: boolean;
  ready: any;
  shouldRequest: Insite.AppState["requestSchedule"]["shouldRequestInsights"];
  error: Insite.AppState["insights"]["error"];
  selectedSites: Insite.AppState["betaSelections"]["selectedSites"];
  showSnoozed: Insite.AppState["insights"]["showSnoozed"];
  urlHistory: Insite.AppState["urlHistory"];
  timeRange: Insite.AppState["betaSelections"]["daysRange"];
  user: Insite.AppState["auth"]["user"];
}

interface DispatchProps {
  setMultiSite: (syncoId: string) => void;
  setShouldRequest: (shouldRequestInsights: boolean) => void;
  requestInsights: (insightType: string, syncoId: string) => void;
  showModal: (
    equipRuleIds: string[],
    hits: any,
    createNewIssue: boolean
  ) => void;
}

interface MatchParams {
  syncoId: string;
  ruleId: string;
  insightType: InsightType;
}

export type Props = RouteComponentProps<MatchParams> &
  ConnectedProps &
  DispatchProps;

const mapStateToProps = (state: Insite.AppState) => ({
  appSetupComplete: state.appSetup.appSetupComplete,
  userSites: state.userSites,
  shouldRequest: state.requestSchedule.shouldRequestInsights,
  error: state.insights.error,
  selectedSites: state.betaSelections.selectedSites,
  showSnoozed: state.insights.showSnoozed,
  urlHistory: state.urlHistory,
  timeRange: state.betaSelections.daysRange,
  user: state.auth.user,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  showModal: (equipRuleIds: string[], hits: any, createNewIssue = false) => {
    // Also include equipNames by searching through all hits to find ones that
    // match the supplied ids
    const equipNames = equipRuleIds
      .map((id: string) => {
        const hit = hits.find((h: any) => h.equipRuleId === id);
        return hit ? hit.targetName : null;
      })
      .filter((h) => h !== null);
    return () =>
      dispatch(
        show("TRIAGE_ACTION_MODAL", {
          equipRuleIds,
          equipNames,
          createNewIssue,
        })
      );
  },
  setMultiSite: (syncoId: string) => {
    dispatch(updateIsMultiSiteRoute(false));
    dispatch(selectActiveSite(syncoId));
  },
  setShouldRequest: (shouldRequestInsights: boolean) => {
    dispatch(setShouldRequestInsights(shouldRequestInsights));
  },
});

const EquipScene: React.FC<Props> = (props) => {
  if (!props.appSetupComplete) return null;
  return <InsightEquips {...props} />;
};

export default connect(mapStateToProps, mapDispatchToProps)(EquipScene);
